(function () {
  const formatMoney = (cents, moneyFormat = window?.Shopify?.money_format || '€{{amount_with_comma_separator}}') => {
    const value = (Number(cents) || 0) / 100;
    const formatted = value.toLocaleString('en-GB', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    return moneyFormat
      .replace('{{amount}}', formatted)
      .replace('{{ amount }}', formatted)
      .replace('{{amount_with_comma_separator}}', formatted)
      .replace('{{ amount_with_comma_separator }}', formatted)
      .replace('{{amount_no_decimals}}', Math.round(value).toString())
      .replace('{{ amount_no_decimals }}', Math.round(value).toString());
  };

  const priceState = {
    mode: localStorage.getItem('pe-price-mode') || 'incl'
  };

  const refreshJudgeMe = () => {
    if (window.jdgm && typeof window.jdgm.loadBadge === 'function') window.jdgm.loadBadge();
    if (window.jdgm && typeof window.jdgm.loadWidgets === 'function') window.jdgm.loadWidgets();
  };

  const setToggleButtons = (mode) => {
    document.querySelectorAll('[data-price-toggle]').forEach((toggle) => {
      toggle.querySelectorAll('button[data-value]').forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.value === mode);
      });
    });
  };

  const applyPriceMode = (root = document) => {
    const mode = priceState.mode;

    root.querySelectorAll('[data-pe-price-box]').forEach((box) => {
      const vatRate = Number(box.dataset.vatRate || 21);

      const saleEl = box.querySelector('[data-pe-sale-price]');
      const compareEl = box.querySelector('[data-pe-compare-price]');
      const compareRow = box.querySelector('[data-pe-adviesprijs-row]');
      const saleLabelEl = box.querySelector('[data-pe-sale-label]');

      if (saleEl) {
        const incl = Number(saleEl.dataset.priceIncl || 0);
        const excl = Math.round(incl / (1 + vatRate / 100));
        saleEl.textContent = formatMoney(mode === 'excl' ? excl : incl);
      }

      if (compareEl && compareRow) {
        const inclCompare = Number(compareEl.dataset.priceIncl || 0);

        if (inclCompare > 0) {
          const exclCompare = Math.round(inclCompare / (1 + vatRate / 100));
          compareEl.textContent = formatMoney(mode === 'excl' ? exclCompare : inclCompare);
          compareRow.hidden = false;
        } else {
          compareEl.textContent = '';
          compareRow.hidden = true;
        }
      }

      if (saleLabelEl) {
        saleLabelEl.textContent =
          mode === 'excl'
            ? (saleLabelEl.dataset.labelExcl || 'Price excl. VAT')
            : (saleLabelEl.dataset.labelIncl || 'Price incl. VAT');
      }
    });

    document.querySelectorAll('[data-pe-sticky-sale-price]').forEach((el) => {
      const vatRate = Number(el.dataset.vatRate || 21);
      const incl = Number(el.dataset.priceIncl || 0);
      const excl = Math.round(incl / (1 + vatRate / 100));
      el.textContent = formatMoney(mode === 'excl' ? excl : incl);
    });

    document.querySelectorAll('[data-pe-sticky-compare-price]').forEach((el) => {
      const vatRate = Number(el.dataset.vatRate || 21);
      const incl = Number(el.dataset.priceIncl || 0);

      if (incl > 0) {
        const excl = Math.round(incl / (1 + vatRate / 100));
        el.textContent = formatMoney(mode === 'excl' ? excl : incl);
        el.hidden = false;
      } else {
        el.textContent = '';
        el.hidden = true;
      }
    });

    setToggleButtons(mode);
  };

  const updateStickyInventory = (variant) => {
    const stickyInventory = document.querySelector('[data-pe-sticky-inventory]');
    if (!stickyInventory || !variant) return;

    const statusEl = stickyInventory.querySelector('.pe-inventory-status');
    const textEl = stickyInventory.querySelector('[data-pe-sticky-inventory-text]');
    if (!statusEl || !textEl) return;

    const isAvailable = !!variant.available;

    statusEl.classList.remove(
      'is-instock',
      'is-extended',
      'is-specialorder',
      'is-preorder',
      'is-backorder',
      'is-serviceorder',
      'is-out',
      'is-rental',
      'is-none'
    );

    statusEl.classList.add(isAvailable ? 'is-instock' : 'is-out');
    textEl.textContent = isAvailable ? 'Available' : 'Sold out';
  };

  const updateStickyComparePrice = (variant) => {
    const stickyCompareEl = document.querySelector('[data-pe-sticky-compare-price]');
    if (!stickyCompareEl || !variant) return;

    const compareAt = Number(variant.compare_at_price || 0);
    const price = Number(variant.price || 0);
    const hasCompare = compareAt > price;

    stickyCompareEl.dataset.priceIncl = hasCompare ? String(compareAt) : '0';
    stickyCompareEl.hidden = !hasCompare;
  };

  const updateStickyImage = (section, variant) => {
    const stickyImg = document.querySelector('[data-pe-sticky-image]');
    if (!stickyImg) return;

    let imageSrc = '';
    let imageSrcset = '';
    let imageAlt = stickyImg.getAttribute('alt') || '';

    if (variant && variant.featured_image) {
      imageSrc = variant.featured_image.src || '';
      imageSrcset = variant.featured_image.srcset || '';
      imageAlt = variant.featured_image.alt || imageAlt;
    } else {
      const sectionFeaturedImg = section?.querySelector('.pe-sticky-bar__thumb img, [data-pe-featured-image]');
      if (sectionFeaturedImg) {
        imageSrc = sectionFeaturedImg.getAttribute('src') || '';
        imageSrcset = sectionFeaturedImg.getAttribute('srcset') || '';
        imageAlt = sectionFeaturedImg.getAttribute('alt') || imageAlt;
      }
    }

    if (imageSrc) stickyImg.setAttribute('src', imageSrc);
    if (imageSrcset) {
      stickyImg.setAttribute('srcset', imageSrcset);
    } else {
      stickyImg.removeAttribute('srcset');
    }
    stickyImg.setAttribute('alt', imageAlt);
  };

  const syncVariantUI = (section, variant) => {
    if (!section || !variant) return;

    const saleEl = section.querySelector('[data-pe-sale-price]');
    const compareEl = section.querySelector('[data-pe-compare-price]');
    const compareRow = section.querySelector('[data-pe-adviesprijs-row]');
    const skuEl = section.querySelector('[data-pe-sku]');
    const skuWrap = section.querySelector('[data-pe-sku-wrapper]');
    const stickySaleEl = document.querySelector('[data-pe-sticky-sale-price]');
    const gallery = section.querySelector('[data-pe-gallery]');

    if (saleEl) {
      saleEl.dataset.priceIncl = variant.price || 0;
    }

    if (stickySaleEl) {
      stickySaleEl.dataset.priceIncl = variant.price || 0;
    }

    if (compareEl && compareRow) {
      const compareAt = Number(variant.compare_at_price || 0);
      const price = Number(variant.price || 0);
      const hasCompare = compareAt > price;

      compareEl.dataset.priceIncl = hasCompare ? String(compareAt) : '0';
      compareRow.hidden = !hasCompare;

      if (!hasCompare) {
        compareEl.textContent = '';
      }
    }

    updateStickyComparePrice(variant);
    updateStickyInventory(variant);
    // sync sticky atc
    (function syncStickyAtcFromVariant(v){
      const bar=document.querySelector('[data-pe-sticky-bar]');
      const btn=bar&&bar.querySelector('[data-pe-sticky-atc]');
      if(!btn||!v) return;
      const labelEl=btn.querySelector('[data-pe-sticky-atc-text]');
      const atcLabel=bar.getAttribute('data-pe-sticky-atc-label')||'Add to cart';
      const soldLabel=bar.getAttribute('data-pe-sticky-sold-label')||'Sold out';
      btn.disabled=!v.available;
      if(labelEl) labelEl.textContent=v.available?atcLabel:soldLabel;
      if(v.id){
        btn.setAttribute('data-pe-sticky-variant-id', String(v.id));
        bar.setAttribute('data-pe-sticky-variant-id', String(v.id));
      }
    })(variant);
    updateStickyImage(section, variant);

    if (skuEl && skuWrap) {
      if (variant.sku) {
        skuEl.textContent = variant.sku;
        skuWrap.hidden = false;
      } else {
        skuWrap.hidden = true;
      }
    }

    if (
      gallery &&
      variant.featured_media_id &&
      typeof gallery.showMedia === 'function'
    ) {
      gallery.showMedia(variant.featured_media_id);
    }

    applyPriceMode(section);
    refreshJudgeMe();

    if (window.peStickyFooterController) {
      window.peStickyFooterController.refresh();
    }
  };

  const bindProductSections = (root = document) => {
    root.querySelectorAll('[data-product-section]').forEach((section) => {
      if (section.dataset.peBound === 'true') return;
      section.dataset.peBound = 'true';

      const variantPricingEl = section.querySelector('[data-pe-variant-pricing]');
      if (!variantPricingEl) return;

      let variantPricingData = null;
      try {
        variantPricingData = JSON.parse(variantPricingEl.textContent);
      } catch {
        return;
      }

      const variants = Array.isArray(variantPricingData.variants) ? variantPricingData.variants : [];

      const getVariantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const getCurrentVariant = () => {
        const variantInput = section.querySelector('form[action*="/cart/add"] input[name="id"]');
        if (variantInput && variantInput.value) {
          const found = getVariantById(variantInput.value);
          if (found) return found;
        }
        return variants[0] || null;
      };

      const update = () => {
        const variant = getCurrentVariant();
        syncVariantUI(section, variant);
      };

      update();

      const form = section.querySelector('form[action*="/cart/add"]');
      if (form) {
        form.addEventListener('change', () => setTimeout(update, 80));
      }

      const variantInput = section.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (variantInput) {
        variantInput.addEventListener('change', update);
      }
    });
  };

  const bindPriceToggle = () => {
    document.querySelectorAll('[data-price-toggle]').forEach((toggle) => {
      if (toggle.dataset.peBound === 'true') return;
      toggle.dataset.peBound = 'true';

      toggle.querySelectorAll('button[data-value]').forEach((button) => {
        button.addEventListener('click', () => {
          priceState.mode = button.dataset.value;
          localStorage.setItem('pe-price-mode', priceState.mode);
          applyPriceMode(document);
        });
      });
    });
  };

  const bindScrollLinks = (root = document) => {
    root.querySelectorAll('[data-scroll-link]').forEach((link) => {
      if (link.dataset.peBound === 'true') return;
      link.dataset.peBound = 'true';

      link.addEventListener('click', (event) => {
        const targetId = link.getAttribute('href');
        if (!targetId || !targetId.startsWith('#')) return;
        const target = document.querySelector(targetId);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  };

  const bindGallery = (root = document) => {
    root.querySelectorAll('[data-pe-gallery]').forEach((gallery) => {
      if (gallery.dataset.peBound === 'true') return;
      gallery.dataset.peBound = 'true';

      const slides = Array.from(gallery.querySelectorAll('[data-media-id]'));
      const thumbs = Array.from(gallery.querySelectorAll('[data-thumb-media-id]'));
      const prevBtn = gallery.querySelector('[data-gallery-prev]');
      const nextBtn = gallery.querySelector('[data-gallery-next]');
      let currentIndex = Math.max(0, slides.findIndex((slide) => !slide.hidden));

      const showIndex = (index) => {
        if (!slides.length) return;
        currentIndex = (index + slides.length) % slides.length;

        slides.forEach((slide, idx) => {
          const isActive = idx === currentIndex;
          slide.hidden = !isActive;
          slide.classList.toggle('is-active', isActive);
        });

        thumbs.forEach((thumb, idx) => {
          thumb.classList.toggle('is-active', idx === currentIndex);
        });
      };

      const showMediaById = (mediaId) => {
        const index = slides.findIndex((slide) => String(slide.dataset.mediaId) === String(mediaId));
        if (index >= 0) showIndex(index);
      };

      thumbs.forEach((thumb, idx) => thumb.addEventListener('click', () => showIndex(idx)));
      if (prevBtn) prevBtn.addEventListener('click', () => showIndex(currentIndex - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => showIndex(currentIndex + 1));

      gallery.showMedia = showMediaById;
    });
  };

  
  const bindStickyAtc = () => {
    const stickyBar = document.querySelector('[data-pe-sticky-bar]');
    if (!stickyBar) return;

    const atcBtn = stickyBar.querySelector('[data-pe-sticky-atc]');
    if (!atcBtn) return;

    const labelEl = atcBtn.querySelector('[data-pe-sticky-atc-text]');
    const atcLabel = stickyBar.getAttribute('data-pe-sticky-atc-label') || 'Add to cart';
    const soldLabel = stickyBar.getAttribute('data-pe-sticky-sold-label') || 'Sold out';

    const getMainAddButton = () =>
      document.querySelector('#pe-buy-box [name="add"]') ||
      document.querySelector('.pe-block--buy [name="add"]') ||
      document.querySelector('product-form [name="add"]') ||
      document.querySelector('form[action*="/cart/add"] [name="add"]') ||
      document.querySelector('button[name="add"], [name="add"]');

    const syncFromMain = () => {
      const main = getMainAddButton();
      if (!main) return;
      const disabled = main.disabled || main.getAttribute('aria-disabled') === 'true';
      atcBtn.disabled = disabled;
      if (labelEl) labelEl.textContent = disabled ? soldLabel : atcLabel;
    };

    if (!atcBtn.dataset.peStickyBound) {
      atcBtn.dataset.peStickyBound = '1';
      atcBtn.addEventListener('click', async (event) => {
        event.preventDefault();
        if (atcBtn.disabled) return;
        const main = getMainAddButton();
        if (main && !main.disabled) {
          main.click();
          return;
        }
        const form =
          document.querySelector('#pe-buy-box form[action*="/cart/add"]') ||
          document.querySelector('product-form form') ||
          document.querySelector('form[action*="/cart/add"]');
        if (form) {
          if (form.requestSubmit) form.requestSubmit();
          else form.submit();
          return;
        }
        const variantInput = document.querySelector('form[action*="/cart/add"] [name="id"], [name="id"]');
        const variantId =
          (variantInput && variantInput.value) ||
          atcBtn.getAttribute('data-pe-sticky-variant-id') ||
          stickyBar.getAttribute('data-pe-sticky-variant-id');
        if (!variantId) return;
        try {
          atcBtn.disabled = true;
          const res = await fetch(window.Shopify?.routes?.root
            ? window.Shopify.routes.root + 'cart/add.js'
            : '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
          });
          if (res.ok) {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            if (window.PUB_SUB_EVENTS && window.publish) {
              try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'sticky-atc' }); } catch (e) {}
            }
            window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
          }
        } catch (e) {
          console && console.warn && console.warn('sticky atc add failed', e);
        } finally {
          // keep disabled only if sold out; otherwise re-enable shortly
          setTimeout(() => { if (!atcBtn.hasAttribute('data-force-disabled')) atcBtn.disabled = false; }, 800);
        }
      });
    }

    syncFromMain();

    const main = getMainAddButton();
    if (main && !main.dataset.peStickyObserved) {
      main.dataset.peStickyObserved = '1';
      const obs = new MutationObserver(syncFromMain);
      obs.observe(main, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
    }

    document.addEventListener('change', (e) => {
      if (e.target && (e.target.name === 'id' || e.target.closest('variant-selects, variant-radios, .product-form'))) {
        setTimeout(syncFromMain, 50);
      }
    });
  };

  const createStickyFooterController = () => {
    const stickyBar = document.querySelector('[data-pe-sticky-bar]');
    if (!stickyBar) return null;

    const getBuyArea = () =>
      document.querySelector('#pe-buy-box') ||
      document.querySelector('.pe-block--buy') ||
      document.querySelector('product-form') ||
      document.querySelector('.product-form') ||
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('[name="add"]')?.closest('form') ||
      document.querySelector('.pe-product__info');

    let rafId = null;

    const update = () => {
      const buyArea = getBuyArea();

      if (!buyArea) {
        const shouldShowFallback = window.scrollY > (window.innerHeight || document.documentElement.clientHeight) * 0.8;
        stickyBar.classList.toggle('is-visible', shouldShowFallback);
        return;
      }

      const rect = buyArea.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      const buyAreaPassed = rect.bottom < 0;
      const minimumScrollReached = window.scrollY > viewportHeight * 0.1;

      stickyBar.classList.toggle('is-visible', buyAreaPassed && minimumScrollReached);
    };

    const requestUpdate = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    window.addEventListener('load', requestUpdate);

    requestUpdate();

    return { refresh: requestUpdate };
  };

  const initAll = (root = document) => {
    bindPriceToggle();
    bindScrollLinks(root);
    bindGallery(root);
    bindProductSections(root);
    applyPriceMode(root);
    refreshJudgeMe();

    if (!window.peStickyFooterController) {
      window.peStickyFooterController = createStickyFooterController();
      bindStickyAtc();
    } else {
      window.peStickyFooterController.refresh();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  window.addEventListener('load', () => {
    setTimeout(() => initAll(document), 120);
  });

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();